
/* START_TEMPLATE */
define('hbs!app/templates/tribute_gift',['hbs','Handlebars', 'hbs!app/templates/_rows','app/templates/_helpers/subview'], function( hbs, Handlebars ){ 
var t = Handlebars.template({"1":function(depth0,helpers,partials,data) {
  var stack1, helperMissing=helpers.helperMissing, buffer = "";
  stack1 = ((helpers.subview || (depth0 && depth0.subview) || helperMissing).call(depth0, depth0, {"name":"subview","hash":{}}));
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, buffer = "<div class=\"at-fields\">\n";
  stack1 = this.invokePartial(partials['./_rows'], '    ', './_rows', depth0, undefined, helpers, partials);
  if (stack1 != null) { buffer += stack1; }
  buffer += "    <div class=\"at-row\">\n        <div class=\"at-tribute-gift\" style=\"display:none\">";
  stack1 = helpers.each.call(depth0, (depth0 != null ? depth0.giftChildren : depth0), {"name":"each","hash":{},"fn":this.program(1, data),"inverse":this.noop});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "</div>\n    </div>\n</div>\n";
},"usePartial":true});
Handlebars.registerPartial('app/templates/tribute_gift', t);
return t;
});
/* END_TEMPLATE */
;
